var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyCartBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "462px",
    height: "135px",
    viewBox: "0 0 462 135",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "empty cart background") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-/-Arcade-/-Player-Club-Store-/-Cart---Empty",
    transform: "translate(-24.000000, -74.000000)",
    fill: "#F5F5F5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.25,129.125886 C15.25,141.87634 -22.75,132.709639 15.25,101.625783 C72.25,55 97.0261826,0 129.25,0 C161.473817,0 184.839404,37.3114279 232.25,29 C279.660596,20.6885721 462.414583,21 462.414583,55 C462.414583,89 351.721346,135.683532 307.735673,129.125886 C278.411891,124.754122 218.916667,124.754122 129.25,129.125886 Z",
    id: "empty-cart-background"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCartBackground);
export default __webpack_public_path__ + "static/media/empty-cart-background.5d71bc0a0c33304960b8aecf6928d380.svg";
export { ForwardRef as ReactComponent };